import { render, staticRenderFns } from "./SelectCaption.vue?vue&type=template&id=704147c1&scoped=true&"
import script from "./SelectCaption.vue?vue&type=script&lang=js&"
export * from "./SelectCaption.vue?vue&type=script&lang=js&"
import style0 from "./SelectCaption.vue?vue&type=style&index=0&id=704147c1&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704147c1",
  null
  
)

export default component.exports